import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FOLDER_SIDEBAR_WIDTH } from 'framework-listing-lib/constants/folders';
import { DEFAULT_PADDING_TOKEN } from 'framework-listing-lib/constants/sizes';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FilterErrorComponent() {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(WarningIcon, {
      size: "300"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.error.filtersError.message"
    })]
  });
}
const Toolbar = styled.div.withConfig({
  displayName: "CrmListingFilterBar__Toolbar"
})(({
  theme,
  $hasViews,
  $isFoldersMode
}) => `
  position: relative;
  z-index: 10;
  padding-block-start: ${theme.space['300']};
  padding-inline-start: ${theme.space['300']};
  margin: 0;

  ${$hasViews && `
    border-inline: ${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']};
    padding-inline-end: ${theme.space['300']};
    `
// load-bearing semicolon
// test folders mode without views before removing
};

  ${$isFoldersMode && `padding-inline-start: ${theme.space['600']};
    margin-inline-start: ${FOLDER_SIDEBAR_WIDTH}px;
    border: none;
    `}
`);
const ToolbarInner = styled.div.withConfig({
  displayName: "CrmListingFilterBar__ToolbarInner"
})(({
  theme,
  $hasViews
}) => `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0;
  margin-block-start: -${theme.space[DEFAULT_PADDING_TOKEN]};
  margin-inline-start: -${theme.space[DEFAULT_PADDING_TOKEN]};


  padding-block-end: ${theme.space[DEFAULT_PADDING_TOKEN]};
  padding-block-start: ${$hasViews && theme.space[DEFAULT_PADDING_TOKEN]};

  > * + * {
    margin-inline-start: ${theme.space[DEFAULT_PADDING_TOKEN]};
  }
`);
const SlotFlexContainer = styled.div.withConfig({
  displayName: "CrmListingFilterBar__SlotFlexContainer"
})(["align-items:center;display:flex;flex-shrink:0;> * + *{margin-inline-start:", ";}"], ({
  theme
}) => theme.space['300']);
const StartSlot = styled(SlotFlexContainer).withConfig({
  displayName: "CrmListingFilterBar__StartSlot"
})(["justify-content:flex-start;flex-grow:1;flex-shrink:1;overflow-x:auto;"]);
const EndSlot = styled(SlotFlexContainer).withConfig({
  displayName: "CrmListingFilterBar__EndSlot"
})(["justify-content:flex-end;"]);
export const CrmListingFilterBar = props => {
  const {
    'data-test-id': dataTestId,
    endSlot,
    startSlot,
    hasViews,
    isFoldersMode
  } = props;
  return /*#__PURE__*/_jsx(Toolbar, {
    role: "group",
    $hasViews: hasViews,
    $isFoldersMode: isFoldersMode,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsxs(ToolbarInner, {
      $hasViews: hasViews,
      children: [startSlot ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StartSlot, {
        children: startSlot
      }) : null, endSlot ? /*#__PURE__*/_jsx(EndSlot, {
        children: endSlot
      }) : null]
    })
  });
};